export default {"src":"/login-app/[GIT_HASH]/_next/static/media/key_option.642b388d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};